module.exports = __webpack_public_path__ + "img/logo.1d746f2c.png";